import { createAction } from '@reduxjs/toolkit'
import {typeDailyStatistic, typePeriod, typeStatisticData} from "./dStatisticsReducer";
import {typeStatisticsRequestFilters} from "./dStatisticsAPI";
import {dateFilterValues} from "../../components/containers/dashboard/dataStatistics";


// ---------------------------------------------------------------------------------------------------------------------
// Action creator of set loader
export const dStatisticsSetLoaderAC = createAction(
    'D_STATISTICS_SET_LOADER',
    ( loaderFilter: boolean ) => ( { payload: { loaderFilter } } )
)
export const dStatisticsSetDailyLoaderAC = createAction(
    'D_STATISTICS_SET_DAILY_LOADER',
    ( loaderDaily: boolean ) => ( { payload: { loaderDaily } } )
)


// ---------------------------------------------------------------------------------------------------------------------
// Action creator of set period
export const dStatisticsSetPeriodAC = createAction(
    'D_STATISTICS_SET_PERIOD',
    ( period: typePeriod, dateFilterId: dateFilterValues ) => ( { payload: { period, dateFilterId } } )
)


// ---------------------------------------------------------------------------------------------------------------------
// Action creator of set stories
export const dStatisticsSetStoriesAC = createAction(
    'D_STATISTICS_SET_STORIES',
    ( stories: string[] ) => ( { payload: { stories } } )
)


// ---------------------------------------------------------------------------------------------------------------------
// Action creator of set sale statistic data
export const dStatisticsSetSaleStatisticDataAC = createAction(
    'D_STATISTICS_SET_SALE_STATISTIC_DATA',
    ( dataObj: typeStatisticData ) => ( { payload: { dataObj } } )
)

// Action creator of set refund statistic data
export const dStatisticsSetRefundStatisticDataAC = createAction(
    'D_STATISTICS_SET_REFUND_STATISTIC_DATA',
    ( dataObj: typeStatisticData ) => ( { payload: { dataObj } } )
)

//----------------------------------------------------------------------------------------------------------------------
// Action creator of set daily statistic data
export const dStatisticsSetDailyStatisticDataAC = createAction(
    'D_STATISTICS_SET_DAILY_STATISTIC_DATA',
    ( dataObj: typeDailyStatistic ) => ( { payload: { dataObj } } )
)



// Action creator of set main sale amount daily statistic data
export const dStatisticsSetMainSaleAmountDailyStatisticDataAC = createAction(
    'D_STATISTICS_SET_MAIN_SALE_AMOUNT_DAILY_STATISTIC_DATA',
    ( dataObj: typeStatisticData ) => ( { payload: { dataObj } } )
)

// Action creator of set main sale amount weekly statistic data
export const dStatisticsSetMainSaleAmountWeeklyStatisticDataAC = createAction(
    'D_STATISTICS_SET_MAIN_SALE_AMOUNT_WEEKLY_STATISTIC_DATA',
    ( dataObj: typeStatisticData ) => ( { payload: { dataObj } } )
)

// Action creator of set main sale amount weekly statistic data
export const dStatisticsSetMainSaleAmountMonthlyStatisticDataAC = createAction(
    'D_STATISTICS_SET_MAIN_SALE_AMOUNT_MONTHLY_STATISTIC_DATA',
    ( dataObj: typeStatisticData ) => ( { payload: { dataObj } } )
)



// Action creator of set main sale count daily statistic data
export const dStatisticsSetMainSaleCountDailyStatisticDataAC = createAction(
    'D_STATISTICS_SET_MAIN_SALE_COUNT_DAILY_STATISTIC_DATA',
    ( dataObj: typeStatisticData ) => ( { payload: { dataObj } } )
)

// Action creator of set main sale count weekly statistic data
export const dStatisticsSetMainSaleCountWeeklyStatisticDataAC = createAction(
    'D_STATISTICS_SET_MAIN_SALE_COUNT_WEEKLY_STATISTIC_DATA',
    ( dataObj: typeStatisticData ) => ( { payload: { dataObj } } )
)

// Action creator of set main sale count weekly statistic data
export const dStatisticsSetMainSaleCountMonthlyStatisticDataAC = createAction(
    'D_STATISTICS_SET_MAIN_SALE_COUNT_MONTHLY_STATISTIC_DATA',
    ( dataObj: typeStatisticData ) => ( { payload: { dataObj } } )
)



// Action creator of set main sale average daily statistic data
export const dStatisticsSetMainSaleAverageDailyStatisticDataAC = createAction(
    'D_STATISTICS_SET_MAIN_SALE_AVERAGE_DAILY_STATISTIC_DATA',
    ( dataObj: typeStatisticData ) => ( { payload: { dataObj } } )
)

// Action creator of set main sale average weekly statistic data
export const dStatisticsSetMainSaleAverageWeeklyStatisticDataAC = createAction(
    'D_STATISTICS_SET_MAIN_SALE_AVERAGE_WEEKLY_STATISTIC_DATA',
    ( dataObj: typeStatisticData ) => ( { payload: { dataObj } } )
)

// Action creator of set main sale average weekly statistic data
export const dStatisticsSetMainSaleAverageMonthlyStatisticDataAC = createAction(
    'D_STATISTICS_SET_MAIN_SALE_AVERAGE_MONTHLY_STATISTIC_DATA',
    ( dataObj: typeStatisticData ) => ( { payload: { dataObj } } )
)



// Action creator of set main refund count daily statistic data
export const dStatisticsSetMainRefundCountDailyStatisticDataAC = createAction(
    'D_STATISTICS_SET_MAIN_REFUND_COUNT_DAILY_STATISTIC_DATA',
    ( dataObj: typeStatisticData ) => ( { payload: { dataObj } } )
)

// Action creator of set main refund count weekly statistic data
export const dStatisticsSetMainRefundCountWeeklyStatisticDataAC = createAction(
    'D_STATISTICS_SET_MAIN_REFUND_COUNT_WEEKLY_STATISTIC_DATA',
    ( dataObj: typeStatisticData ) => ( { payload: { dataObj } } )
)

// Action creator of set main refund count weekly statistic data
export const dStatisticsSetMainRefundCountMonthlyStatisticDataAC = createAction(
    'D_STATISTICS_SET_MAIN_REFUND_COUNT_MONTHLY_STATISTIC_DATA',
    ( dataObj: typeStatisticData ) => ( { payload: { dataObj } } )
)



// Action creator of set main refund amount daily statistic data
export const dStatisticsSetMainRefundAmountDailyStatisticDataAC = createAction(
    'D_STATISTICS_SET_MAIN_REFUND_AMOUNT_DAILY_STATISTIC_DATA',
    ( dataObj: typeStatisticData ) => ( { payload: { dataObj } } )
)

// Action creator of set main refund amount weekly statistic data
export const dStatisticsSetMainRefundAmountWeeklyStatisticDataAC = createAction(
    'D_STATISTICS_SET_MAIN_REFUND_AMOUNT_WEEKLY_STATISTIC_DATA',
    ( dataObj: typeStatisticData ) => ( { payload: { dataObj } } )
)

// Action creator of set main refund amount weekly statistic data
export const dStatisticsSetMainRefundAmountMonthlyStatisticDataAC = createAction(
    'D_STATISTICS_SET_MAIN_REFUND_AMOUNT_MONTHLY_STATISTIC_DATA',
    ( dataObj: typeStatisticData ) => ( { payload: { dataObj } } )
)



// Action creator of set hours statistic data
export const dStatisticsSetHoursStatisticDataAC = createAction(
    'D_STATISTICS_SET_HOURS_STATISTIC_DATA',
    ( dataObj: typeStatisticData ) => ( { payload: { dataObj } } )
)

// Action creator of set main statistic data
export const dStatisticsSetWeekDayStatisticDataAC = createAction(
    'D_STATISTICS_SET_WEEK_DAY_STATISTIC_DATA',
    ( dataObj: typeStatisticData ) => ( { payload: { dataObj } } )
)

// Action creator of set payment method amount statistic data
export const dStatisticsSetPaymentMethodAmountStatisticDataAC = createAction(
    'D_STATISTICS_SET_PAYMENT_METHOD_AMOUNT_STATISTIC_DATA',
    ( dataObj: typeStatisticData ) => ( { payload: { dataObj } } )
)

// Action creator of set payment method count statistic data
export const dStatisticsSetPaymentMethodCountStatisticDataAC = createAction(
    'D_STATISTICS_SET_PAYMENT_METHOD_COUNT_STATISTIC_DATA',
    ( dataObj: typeStatisticData ) => ( { payload: { dataObj } } )
)

// Action creator of set payment type amount statistic data
export const dStatisticsSetSaleTypeAmountStatisticDataAC = createAction(
    'D_STATISTICS_SET_PAYMENT_TYPE_AMOUNT_STATISTIC_DATA',
    ( dataObj: typeStatisticData ) => ( { payload: { dataObj } } )
)

// Action creator of set payment type count statistic data
export const dStatisticsSetSaleTypeCountStatisticDataAC = createAction(
    'D_STATISTICS_SET_PAYMENT_TYPE_COUNT_STATISTIC_DATA',
    ( dataObj: typeStatisticData ) => ( { payload: { dataObj } } )
)

// Action creator of set employee statistic data
export const dStatisticsSetEmployeeStatisticDataAC = createAction(
    'D_STATISTICS_SET_EMPLOYEE_STATISTIC_DATA',
    ( dataObj: typeStatisticData ) => ( { payload: { dataObj } } )
)

// Action creator of set product statistic data
export const dStatisticsSetProductStatisticDataAC = createAction(
    'D_STATISTICS_SET_PRODUCT_STATISTIC_DATA',
    ( dataSaleObj: typeStatisticData, dataRefundObj: typeStatisticData) => ( { payload: { dataSaleObj, dataRefundObj } } )
)



// Action creator of set full employee statistic data
export const dStatisticsSetFullEmployeeStatisticDataAC = createAction(
    'D_STATISTICS_SET_FULL_EMPLOYEE_STATISTIC_DATA',
    ( saleDataObj: typeStatisticData | null,  refundDataObj: typeStatisticData | null,) => ( { payload: { saleDataObj, refundDataObj } } )
)

// Action creator of set full product statistic data
export const dStatisticsSetFullProductStatisticDataAC = createAction(
    'D_STATISTICS_SET_FULL_PRODUCT_STATISTIC_DATA',
    ( saleDataObj: typeStatisticData | null,  refundDataObj: typeStatisticData | null,) => ( { payload: { saleDataObj, refundDataObj } } )
)



// SAGAS

// ---------------------------------------------------------------------------------------------------------------------
// Action creator of saga set data
export const dStatisticsSetDailyDataSagaAC = createAction(
    'D_STATISTICS_SET_DAILY_DATA_SAGA',
    ( statisticFilter: typeStatisticsRequestFilters ) => ( { payload: { statisticFilter } } )
)

// Action creator of saga set data
export const dStatisticsSetDataSagaAC = createAction(
    'D_STATISTICS_SET_DATA_SAGA',
    ( statisticFilter: typeStatisticsRequestFilters ) => ( { payload: { statisticFilter } } )
)